<template>
  <v-form @submit.prevent="login">
    <v-text-field
      v-model="username"
      label="Username"
      required
    ></v-text-field>
    <v-text-field
      v-model="password"
      label="Password"
      type="password"
      required
    ></v-text-field>
    <v-btn :loading="loading" type="submit" color="primary">
      Login
    </v-btn>
  </v-form>
</template>

<script>
export default {
  data() {
    return {
      username: '',
      password: '',
      loading: false
    };
  },
  methods: {
    async login() {
      if (!this.username.trim() || !this.password.trim()) return;
      this.loading = true;
      try {
        const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/auth`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ username: this.username, password: this.password })
        });
        const data = await response.json();
        if (response.ok) {
          this.$emit('login-success', data.access_token);
        } else {
          throw new Error(data.error || 'Login failed');
        }
      } catch (error) {
        console.error('Login error:', error);
        this.$emit('login-error', error.message);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>